import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  fetchPublisherEmergencyReportByPublisherId,
  publishersGetMe,
} from '~/generated';

const Index = () => {
  return null;
};

export const Route = createFileRoute('/')({
  component: Index,
  loader: async () => {
    const { data: publisher } = await publishersGetMe();
    if (!publisher) {
      window.location.href = 'Identity/Account/Login';
      return;
    }
    const { data: emergencyData } =
      await fetchPublisherEmergencyReportByPublisherId({
        path: { publisherId: publisher.id },
      });
    if (emergencyData) {
      throw redirect({ to: '/emergency-status' });
    }
    throw redirect({ to: '/home' });
  },
});
